import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const ACCOUNT_BASE_INLINE_FRAGMENT = graphql`
  fragment accountBaseInlineFragment on Account @inline {
    id
    externalRef
    name
    platformAccess
    createdAt
  }
`;

export const ACCOUNT_BASE_FRAGMENT = graphql`
  fragment accountBaseFragment on Account {
    id
    externalRef
    name
    platformAccess
    createdAt
  }
`;

export const ACCOUNT_ADDRESS_FRAGMENT = graphql`
  fragment accountAddressFragment on Account {
    addressLineOne
    addressLineTwo
    city
    state
    countryId
    zip
  }
`;

export const ACCOUNT_DETAILS_FRAGMENT = graphql`
  fragment accountDetailsFragment on Account {
    website
    urls
    description
    phone
    businessLogoUrls
    coverPhotoUrls
  }
`;

export const ACCOUNT_FINANCIAL_FRAGMENT = graphql`
  fragment accountFinancialFragment on Account {
    paypalDetails
    stripeDetails
    stripeRef
  }
`;

export const ACCOUNT_CONNECT_DETAIL_INLINE_FRAGMENT = graphql`
  fragment accountConnectDetailInlineFragment on AccountDetailConnect @inline {
    type
    meetSubdomain
    businessNumber
    latitude
    longitude
  }
`;

export const ACCOUNT_CONNECT_DETAIL_FRAGMENT = graphql`
  fragment accountConnectDetailFragment on AccountDetailConnect {
    type
    meetSubdomain
    businessNumber
    latitude
    longitude
  }
`;

export const ACCOUNT_BILLING_INFO_BASE_FRAGMENT = graphql`
  fragment accountBillingInfoBaseFragment on AccountBillingInfo {
    id
    extraBillingInformation
  }
`;

export const ACCOUNT_BILLING_INFO_CARD_FRAGMENT = graphql`
  fragment accountBillingInfoCardFragment on AccountBillingInfo {
    cardBrand
    cardLastFour
    cardCountryId
  }
`;

export const ACCOUNT_BILLING_INFO_ADDRESS_FRAGMENT = graphql`
  fragment accountBillingInfoAddressFragment on AccountBillingInfo {
    billingAddressLineOne
    billingAddressLineTwo
    billingCity
    billingState
    billingCountryId
    billingZip
    billingCountry {
      ...countryFragment
    }
  }
`;

/**
 * Queries
 */
export const ACCOUNT_QUERY = graphql`
  query accountQuery($id: ID!) {
    account(id: $id) {
      ...accountBaseInlineFragment
      ...accountBaseFragment
      ...accountAddressFragment
      ...accountDetailsFragment
      ...accountFinancialFragment
      accountDetailConnect {
        ...accountConnectDetailInlineFragment
        ...accountConnectDetailFragment
      }
      accountBillingInfos {
        ...accountBillingInfoBaseFragment
        ...accountBillingInfoCardFragment
        ...accountBillingInfoAddressFragment
      }
    }
  }
`;

/**
 * Mutations
 */

export const ACCOUNT_UPDATE_MUTATION = graphql`
  mutation accountUpdateMutation($id: ID!, $input: AccountUpdateInput!) {
    updateAccount(id: $id, input: $input) {
      account {
        ...accountBaseInlineFragment
        ...accountAddressFragment
        ...accountDetailsFragment
        ...accountFinancialFragment
      }
    }
  }
`;

export const ACCOUNT_BILLING_INFO_CREATE_MUTATION = graphql`
  mutation accountBillingInfoCreateMutation($input: AccountBillingInfoCreateInput!) {
    createAccountBillingInfo(input: $input) {
      accountBillingInfo {
        ...accountBillingInfoBaseFragment
        ...accountBillingInfoCardFragment
        ...accountBillingInfoAddressFragment
      }
    }
  }
`;

export const ACCOUNT_BILLING_INFO_UPDATE_MUTATION = graphql`
  mutation accountBillingInfoUpdateMutation($id: ID!, $input: AccountBillingInfoUpdateInput!) {
    updateAccountBillingInfo(id: $id, input: $input) {
      accountBillingInfo {
        ...accountBillingInfoBaseFragment
        ...accountBillingInfoCardFragment
        ...accountBillingInfoAddressFragment
      }
    }
  }
`;

export const ACCOUNT_DETAILS_CONNECT_UPDATE_MUTATION = graphql`
  mutation accountBillingConnectUpdateMutation($id: ID!, $input: AccountDetailConnectUpdateInput!) {
    updateAccountDetailConnect(id: $id, input: $input) {
      accountDetailConnect {
        ...accountConnectDetailInlineFragment
      }
    }
  }
`;

export const ACCOUNT_DELETE_MUTATION = graphql`
  mutation accountDeleteMutation($id: ID!) {
    deleteAccount(id: $id) {
      id
    }
  }
`;

export const ACCOUNT_CREATE_STRIPE_CONNECT_ACCOUNT_LINK_MUTATION = graphql`
  mutation accountCreateStripeConnectAccountLinkMutation {
    createStripeConnectAccountLink
  }
`;

export const ACCOUNT_CREATE_STRIPE_CONNECT_DASHBOARD_LINK_MUTATION = graphql`
  mutation accountCreateStripeConnectDashboardLinkMutation {
    createStripeConnectDashboardLink
  }
`;
